import { addDocuments, addAnswers } from './tools'
import demos from '../../demos'

const documents = {
    'demo.general': [
        'doen jullie ook demos geven',
    ],
    'demo.search': [
        'Heb je een demo over %demo%?',
        'demo van %demo%?',
        '%demo% laten zien',
        'doen jullie iets met %demo%',
        'voorbeeld %demo%',
    ],
}

const answers = {
    'demo.general': [
        'In de balk hierboven kun je een lijstje zien van wat we zoal doen. Je kunt me ook vragen om een specifieke techniek of toepassing.',
        'Vraag me maar eens over een specifieke techniek of toepassing.',
    ],
    'demo.search': [
        'Eens kijken of we demo\'s hebben over "{{demo}}":',
        'Eens kijken of we iets kunnen laten zien over "{{demo}}":',
        'Laat ik eens zoeken naar demo\'s over "{{demo}}":',
        'Zoeken naar demo\'s....',
    ],
}

export default function (manager) {
    // TODO: use actual vuex store? (but training may need to be done at build time)
    demos.state.demos.forEach((demo) => {
        // TODO: stem search terms
        manager.nerManager.addNamedEntityText('demo', demo.name, ['nl'], demo.searchTerms || [demo.name])
    })

    addDocuments(manager, documents, 'nl')
    addAnswers(manager, answers, 'nl')

    manager.slotManager.addSlot('demo.search', 'demo', true, { nl: 'Waar zou je graag een demo van zien?' })
}
